 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML04_COPYRIGH from '@/components/html/04_Copyrigh'
 import HTML03_TITLE_PA from '@/components/html/03_Title_Pa'
 import HTML02_IMAGE from '@/components/html/02_Image'
 import HTML05_DEDICATI from '@/components/html/05_Dedicati'
 import HTML06_FRONT_MA from '@/components/html/06_Front_Ma'
 import HTML07_CONTENTS from '@/components/html/07_Contents'
 import HTML08_ACKNOWLE from '@/components/html/08_Acknowle'
 import HTML09_INTRODUC from '@/components/html/09_Introduc'
 import HTML10_1_THE_GR from '@/components/html/10_1_The_Gr'
 import HTML11_2_A_MONO from '@/components/html/11_2_A_Mono'
 import HTML12_3_THE_BA from '@/components/html/12_3_The_Ba'
 import HTML13_4_EXPERI from '@/components/html/13_4_Experi'
 import HTML14_5_SKIRMI from '@/components/html/14_5_Skirmi'
 import HTML15_6_STRANG from '@/components/html/15_6_Strang'
 import HTML16_CONCLUSI from '@/components/html/16_Conclusi'
 import HTML17_ABBREVIA from '@/components/html/17_Abbrevia'
 import HTML18_NOTES from '@/components/html/18_Notes'
 import HTML19_INDEX from '@/components/html/19_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/07_Contents",
 			"name" : "html/07_Contents",
 			"component" : HTML07_CONTENTS
 		},
 		{
 			"path" : "/html/08_Acknowle",
 			"name" : "html/08_Acknowle",
 			"component" : HTML08_ACKNOWLE
 		},
 		{
 			"path" : "/html/09_Introduc",
 			"name" : "html/09_Introduc",
 			"component" : HTML09_INTRODUC
 		},
 		{
 			"path" : "/html/10_1_The_Gr",
 			"name" : "html/10_1_The_Gr",
 			"component" : HTML10_1_THE_GR
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js